import { z } from "zod";

export const hallowRequestTypeEnum = z.enum(["auth", "trusted", "search"]);

export type HallowRequestType = z.infer<typeof hallowRequestTypeEnum>;
